<template>
    <div>
        <b-btn @click="show" class="mt-3" style="font-size:1.1rem" :disabled="loading" variant="outline-warning">Print Customer Receipt
        </b-btn>
        <CModal
            v-model="showPrint"
            confirmLabel="Select & Print"
            centered
            :size="'md'"
            
            title="Select a Printer"
            :tag="false"
            :progressing="loading"
            @hide="hide"
            @submit="submit">
                <b-row class=" ml-2 px-2 ">

                    <b-form-group label=""  :style="{'overflow-x':'scroll !important'}" v-slot="{ ariaDescribedby }" class="mx-4  flex-grow-1 justify-content-cente">
                            <b-form-radio-group
                            
                                    v-model="selectedPrinter"
                                    :options="printerList"
                                    :aria-describedby="ariaDescribedby"
                                    :style="{gap:'1rem', 'text-wrap': 'nowrap'}"
                                    buttons
                                    size="lg"
                                    button-variant="outline-warning"
                            ></b-form-radio-group>
                    </b-form-group>
                </b-row>
        </CModal>
    </div>

</template>

<script>
    import moment from "moment";
    import CModal from "../shared/Cmodal.vue"
    export default {
        name: "printRecipient",
        components:{
            CModal
        },
        props: {
            items: {
                required: true
            },
            info: {
                required: true
            },
            printMethod: {required: true,
            default: "API"},
            AllowSecondLang: {
                required: false
            },
            HasActiveTicketPrinter: {
                required: true
            },
            HasActiveReceiptPrinter: {
                required: true
            },
            printers: {
                required: true
            },
            serverIp: {
                required: true
            },
            RestaurantName: {
                required: true
            },
            RestaurantAddress: {
                required: true
            },
            RestaurantPhoneNumber: {
                required: true
            },
            cardInfo: {
                required: true
            },
            RestaurantState: {required: true},
            RestaurantZIP: {required: true},
            RestaurantCity: {required: true},
        },
        data () {
            return {
                errorJSPM: '',
                availablePrinters: this.printers,
                loading: false,
                showPrint:false,
                selectedPrinter:"",
                printerList:[]
            }
        },

       
        methods: {
            show(){
               

                let numOfUnlinkedPrinter = this.printers.filter(el=>el.IsLinked != true).length

                if(this.printers.length === 1 || numOfUnlinkedPrinter === 1){
                    return this.print()
                }
                if(numOfUnlinkedPrinter > 1){
                    this.showPrint = true
                }
                if(this.printers.length > 1 && this.printers.length != this.printerList.length){
                    this.printerList = []
                    this.printers.forEach(el => {
                        if(!el.IsLinked)
                            this.printerList.push(el.PrinterName)
                    });
                    this.selectedPrinter = this.printerList[0]
                }else{
                    this.selectedPrinter = this.printerList[0]
                }
            },
            hide(){
                this.showPrint = false
            },
            submit(){
                this.print(true)
            },
            translateOrderType (date) {
                moment.locale('en-ca');
                return moment(date).format('MMMM D, YYYY hh:mm A')
            },
            showTableNumber (order) {
                if (order.OrderTypeID === 2) {
                    return  ' - ' +order.TableNumber
                } else {
                    return ''
                }
            },
            print (selected=false) {
                this.loading = true
                if(this.printMethod.toUpperCase() === "API"){//run new code
                    this.loading = true
                    const model = {
                        RestaurantID:this.$store.state.selectedRestaurantId,
                        OrderID:this.info.OrderID,
                        Type:"customer-receipt",
                        SelectedIds:[]
                    }
                



                    if(this.printers.length === 0 )
                        return
                    
                    if(!selected){
                        model.SelectedIds[0] = {
                                IpAddress:this.printers[0].IPAddress,
                                Port: this.printers[0].Port,
                                ItemID: this.items[0].ItemID,
                            }   
                    }else{
                            let tmp
                            let printerIndex
                            tmp = this.printers.find(el=>el.PrinterName == this.selectedPrinter)
                            printerIndex = this.printers.indexOf(tmp)
                            model.SelectedIds[0] = {
                                IpAddress:this.printers[printerIndex].IPAddress,
                                Port: this.printers[printerIndex].Port,
                                ItemID: this.items[0].ItemID,
                            }  
                    }
                     
                    
                    
            
                this.$api.getRestaurant.SendOrderPrintToApp(model).then(res=>{
                    
                    if(!res.success){
                        
                        this.$emit('callbackResult', {
                        hasError: true,
                        printTab: true,
                        message: "Error occured during printing",
                        
                        })
                    }
                    this.loading = false
                })
                if(selected){
                    this.showPrint = false
                }
                    
                    return
                }
                if (!this.HasActiveReceiptPrinter) {
                    this.$emit('callbackResult', {
                        hasError: true,
                        printTab: true,
                        message: 'No customer receipt printer set.'
                    })
                }
                this.loading = false
                
                
            },
           
        }
    }
</script>

<style scoped>
    .btn.disabled, .btn:disabled {
        color: #90a4ae !important;
        background: #eceff1 !important;
        border: 1px solid #90a4ae !important;
    }
</style>
